import { AgentResultsParseError, extractResultsJsonTextFromPlainText, parseAgentSignatureResults, parseSignatureFieldsFromEvents, } from './parse_agent_results';
/**
 * Reads an Agent Studio streaming body (`Content-Type: text/event-stream`, Vercel AI stream protocol v1).
 * Token deltas use lines `0:<json-string>` (see orbit-server `createVercelStreamFormatter`).
 */
export async function collectVercelAgentStream(body) {
    if (!body) {
        return { tokenText: '', dataEvents: [] };
    }
    const reader = body.getReader();
    const decoder = new TextDecoder();
    let pending = '';
    let tokenText = '';
    const dataEvents = [];
    let streamError;
    const processLine = (line) => {
        const trimmed = line.replace(/\r$/, '');
        if (!trimmed) {
            return;
        }
        if (trimmed.startsWith('0:')) {
            try {
                const piece = JSON.parse(trimmed.slice(2));
                if (typeof piece === 'string') {
                    tokenText += piece;
                }
            }
            catch {
                // TODO: handle and log this error
            }
            return;
        }
        if (trimmed.startsWith('2:')) {
            try {
                const payload = JSON.parse(trimmed.slice(2));
                if (Array.isArray(payload)) {
                    for (const item of payload) {
                        dataEvents.push(item);
                    }
                }
            }
            catch {
                // TODO: handle and log this error
            }
            return;
        }
        if (trimmed.startsWith('3:')) {
            try {
                const err = JSON.parse(trimmed.slice(2));
                streamError = typeof err === 'string' ? err : JSON.stringify(err);
            }
            catch {
                streamError = trimmed.slice(2);
            }
        }
    };
    try {
        for (;;) {
            const { done, value } = await reader.read();
            if (done) {
                break;
            }
            pending += decoder.decode(value, { stream: true });
            const lines = pending.split('\n');
            pending = lines.pop() ?? '';
            for (const line of lines) {
                processLine(line);
            }
        }
        if (pending.trim()) {
            processLine(pending);
        }
    }
    finally {
        reader.releaseLock();
    }
    return { tokenText, dataEvents, streamError };
}
/**
 * Parses `<results>...</results>` from streamed assistant output (token text and/or `2:` data events).
 */
export async function parseSignatureFieldsFromVercelStream(body) {
    const { tokenText, dataEvents, streamError } = await collectVercelAgentStream(body);
    if (streamError) {
        throw new AgentResultsParseError(streamError);
    }
    const fromPlain = extractResultsJsonTextFromPlainText(tokenText);
    if (fromPlain !== undefined) {
        return parseAgentSignatureResults(fromPlain);
    }
    if (dataEvents.length > 0) {
        try {
            return parseSignatureFieldsFromEvents(dataEvents);
        }
        catch (e) {
            if (e instanceof AgentResultsParseError) {
                throw e;
            }
        }
    }
    throw new AgentResultsParseError('No <results>...</results> block found in agent response');
}
